import type { SoldToCustomer } from './unloadedSpaReport';

/**
 * A customer list pasted from Excel or an email table: one customer per
 * line, a name and an all-digits sold-to number in either order, split by
 * tabs, commas or runs of spaces. Lines with no number, like a header row,
 * are skipped. The number keeps its leading zeros.
 */
export function parseCustomerList(text: string): SoldToCustomer[] {
  const customers: SoldToCustomer[] = [];
  const seen = new Set<string>();
  for (const line of text.split(/\r?\n/)) {
    const cells = line
      .split(/\t|,|\s{2,}/)
      .map((part) => part.trim())
      .filter(Boolean);
    const numberIndex = cells.findIndex((part) => /^\d+$/.test(part));
    if (numberIndex < 0) continue;
    const number = cells[numberIndex] ?? '';
    const name = cells.filter((_, index) => index !== numberIndex).join(' ');
    if (name === '' || seen.has(number)) continue;
    seen.add(number);
    customers.push({ name, number });
  }
  return customers;
}
